<template>
    <layout>
      <div class="greetings">
        <TitleLable parentMessage="考试列表"></TitleLable>
        <el-button v-if="is_admin" @click="dialogVisibleChart = true" style="margin-bottom: 15px;" class="el-icon-data-line" size="small" type="primary"> 成绩对比</el-button>
        <el-button v-if="is_admin" @click="changePlan(0)" style="margin-bottom: 15px;" class="el-icon-monitor" size="small" type="primary"> 全部班级</el-button>
        <el-button v-if="is_admin" @click="changePlan(1)" style="margin-bottom: 15px;" class="el-icon-mobile-phone" size="small" type="danger"> 我的班级</el-button>
        <el-button @click="goCreatePage" style="margin-bottom: 15px;" class="el-icon-plus" size="small" type="primary"> 发布考试</el-button>
        <div style="display: inline-block;width: 100%;text-align: right;">
            <el-input size="small" @input="changeKeyword" v-model="form.keyword" placeholder="请输入班级名称"></el-input>
            <span class="trem" v-for="(item,index) in new_trem" :key="index" @click="clickTrem(index)" :style="trem_index==index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
            <el-button @click="downGrade" style="margin-bottom: 15px;" class="el-icon-download" size="small" type="primary">导出成绩</el-button>
        </div>
        
        <el-card v-for="(item,index) in list" :key="index" class="list" shadow="hover">

            <div class="exam_title_box"> 
                <span class="exam_number">{{ index+1 }}</span>
                
                <span v-if="item.makeup" style="color: #f56c6c;border: none;padding-right: 0;" class="exam_name">补考</span>
                <span :style="item.status == 0?'color: #409EFF;':(item.status==1?'color: #f56c6c;':'color: #909399;')" size="large" type="text">{{ status[item.status] }}</span>
                <span style="color: #409EFF;border: none;padding-right: 0;" class="exam_name">{{ item.plan_name }} {{ item.trem }}阶段考试</span>
                
                <span class="exam_name">{{ item.title }}</span>
                <span class="exam_score">总分: {{ item.getTotalScore }}分</span>
            </div>
            <div class="exam_info">发布时间: {{ item.createtime }}</div>
            <div class="exam_info">发布老师: {{ item.teach_name }}</div>
            <div class="exam_info">考试时间: {{ item.start_time_text }} 至 {{ item.end_time_text }}</div>
            <el-divider></el-divider>
            <el-button type="primary" @click="preview(item)" size="small" class="el-icon-monitor" plain> 预览试卷</el-button>
            <!-- <el-button type="primary" size="small" class="el-icon-download" plain> 导出试卷</el-button> -->
            <!-- <el-button type="primary" size="small" class="el-icon-edit" plain> 编辑试卷</el-button> -->
            <el-button type="primary" @click="student(item)" size="small" class="el-icon-monitor" plain> 考试详情</el-button>
            <el-button @click="del(item)" type="danger" size="small" class="el-icon-delete" plain> 删除</el-button>

            <div class="exam_correct">
                <div class="left">
                    <span>{{ item.is_correct }}</span>
                    <span>已批改</span>
                </div>
                <div class="right">
                    <span>{{ item.no_correct }}</span>
                    <span>未批改</span>
                </div>
            </div>

        </el-card>
        <el-empty v-if="!list.length" description="暂无考试信息"></el-empty>
        <el-pagination
            v-if="total_number"
            style="margin-top: 20px;"
            @size-change="changeSize"
            @current-change="changeNumber"
            @prev-click="prev"
            @next-click="next"
            :page-size="form.pageSize"
            :total="total_number">
        </el-pagination>
        <el-dialog
            title="试卷预览"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose">
                <div v-for="(item,index) in bank_data" :key="index" class="content_paper">
                    <h3 style="color: #000000;">{{ item.name }}</h3>
                    <div v-for="(test_item,test_index) in item.items" :key="test_item">
                        <h4 style="color: #f56c6c;">试卷选题 {{ test_index+1 }}</h4>
                        <div style="color: #000000;line-height: 25px;" v-html="test_item.body"></div>
                        <div v-for="(questionitem,questionindex) in test_item.test" :key="questionindex" class="readtest">
                            <div>
                                <h4 style="color: #000000;">{{ questionindex+1 }}. {{ questionitem.question }}</h4>
                                <div :style="!answeritem || answeritem =='/'?'display:none':''" v-for="(answeritem,answerindex) in questionitem.answer" :key="answerindex" class="question_test" >{{ options[answerindex] }}. {{ answeritem }}</div>
                            </div>
                        </div>
                    </div>
                    
                </div>
           
        </el-dialog>


        <el-dialog
            title="成绩对比图"
            :visible.sync="dialogVisibleChart"
            width="50%"
            >

            <div class="trem_data_box">
                <el-checkbox-group v-model="trem" @change="handChange" size="small">
                    <el-checkbox v-for="(item,index) in trem_data" :key="index" :label="item" border></el-checkbox>
                </el-checkbox-group>
            </div>

            <DiffChart v-if="trem.length" :trem="trem"></DiffChart>
        </el-dialog>


      </div>
    </layout>
</template>

<script>
import TitleLable from '../../units/Titlelabel.vue';
import Http from "../../apis/teach";
import axios from 'axios';
import DiffChart from '../../units/diffchart.vue';

export default {
    components:{
        TitleLable,
        DiffChart
    },
    data(){
        return{
            dialogVisible:false,
            list:[],
            status:['未开始','进行中','已结束'],
            bank_data:[],
            options:['A','B','C','D'],
            pdoptions:['T','F'],
            total_number:0,
            new_trem:[],
            trem_index:'',
            form:{
                page:1,
                pageSize:5,
                trem_param:'',
                keyword:'',
                is_all:0
            },
            is_admin:0,
            dialogVisibleChart:false,
            trem_data:[],
            trem:[]
        }
    },
    activated(){
        var user_info = JSON.parse(localStorage.getItem('userinfo'))
        this.is_admin = user_info.is_admin
        this.getExamList()
        this.getSchoolTremGrade()
    },
    methods:{
        handChange(e){
            console.log(e)
        },
        getSchoolTremGrade(){
            Http.getSchoolTremGrade().then((res) => {
                
                this.trem_data = res.data
            });
        },
        gotrem(){
            this.$router.push({ name: 'Trem'})
        },
        downGrade(){
            if(!this.trem_index){
                this.$message({
                    type: 'error',
                    message: '请先选择需要导出成绩的阶段'
                })
                return false;
            }
            const fileUrl = `${axios.defaults.baseURL}/api/teach/downAllPlanExcel?token=${localStorage.getItem("token")}&trem=${this.trem_index}`;

            location.href = fileUrl

        },
        changePlan(type){
            this.form.is_all = type
            this.getExamList()
        },
        clickTrem(index){
            this.form.trem_param = index
            this.trem_index = index
            this.getExamList()
        },
        changeKeyword(){
            this.getExamList()
        },
        getExamList(){

            Http.examList(this.form).then((res) => {
                if(!res.code){
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                    return false;
                }
                this.list = res.data.data
                this.total_number = res.data.total_number
                this.new_trem = res.data.new_trem
            });
        },
        preview(item){
            const loading = this.$loading({
                lock: true,
                text: '请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            var params = {}
            params.trem = item.trem
            params.grade = item.grade
            Http.previewExam(params).then((res) => {
                loading.close()
                this.bank_data = res.data
                this.dialogVisible = true
            });

        },
        handleClose(){
            this.dialogVisible = false
        },
        goCreatePage(){
            this.$router.push({ name: 'Addplan' });
        },
        student(item){
            this.$router.push({ name: 'Studentlist',query:{plan_id:item.plan_id,trem:item.trem,exam_id:item.id,nid:item.id}});
        },
        del(item){

            this.$confirm('删除后该班级所有学生将不再能看到考试信息，此操作会同时删除掉补考信息，是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delExam_(item)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
      
        },
        delExam_(item){
            var params = {}
            params.trem = item.trem
            params.plan_id = item.plan_id
            params.exam_id = item.id
            Http.delExam(params).then((res) => {
                this.$message({
                    type: res.code?'success':'error',
                    message: res.msg
                });
                if(res.code){
                    this.getExamList()
                }
            });

        },
        // 上一页
        prev(e){

            this.form.page = e
            this.getExamList()
        },

        // 下一页
        next(e){

            this.form.page = e
            this.getExamList()
        },

        // 点击页码
        changeNumber(e){

            this.form.page = e
            this.getExamList()
        },

        // 前往指定页数
        changeSize(e){

            this.form.page = e
            this.getExamList()
        }
    }
}
</script>
<style lang="less" scoped>
.trem{
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.greetings::v-deep .el-dialog{
    border-radius: 10px;
}
.greetings::v-deep .el-dialog{
    margin-top: 5vh !important;
    min-height: 600px;
    overflow-y: auto;
}
.greetings::v-deep .el-dialog__title{
    font-weight: 700;
    color: #000000;
}
.greetings::v-deep .el-dialog::-webkit-scrollbar {  
  width: 10px; /* 滚动条的宽度 */  
}  
  
.greetings::v-deep .el-dialog::-webkit-scrollbar-track {  
  background: rgba(0, 0, 0, 0); /* 滚动条轨道的背景色，设置透明度 */  
}  
  
.greetings::v-deep .el-dialog::v-deep .el-dialog::-webkit-scrollbar-thumb {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块的颜色，设置透明度 */  
  border-radius: 10px; /* 圆角效果 */  
}  
  
.greetings::v-deep .el-dialog::-webkit-scrollbar-thumb:hover {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块hover时的颜色，设置透明度 */  
}
.greetings::v-deep .el-dialog__header{
    position: sticky;
    top: 0;
    background-color: #ffffff;
}
.trem_data_box{
    margin-bottom: 20px;
}
.trem_data_box::v-deep .el-checkbox-group{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 15px;
}
.trem_data_box::v-deep .el-checkbox{
    margin-right: 0px !important;
    margin-left: 0px !important;
}
.greetings{

    .list{
        position: relative;
        margin-bottom: 20px;
    }
  
    .exam_correct{
        padding: 15px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;


        span{
            width: 100%;
            display: inline-block;
            text-align: center;
            cursor: pointer;
        }
        .left{
            width: 100px;
            float: left;
            border-right:1px #C8C9CB solid;
            color: #338ACE;
        }
        .right{
            width: 100px;
            float: left;
            color: #F48687;
        }
    }

    .el-pagination{
        text-align: center;
    }
}

.exam_title_box{
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;

    span{
        float: left;
        margin-right: 15px;
    }
    .exam_name{
        padding-right: 15px;
        border-right: 2px #686868 solid;
        font-weight: 700;
        line-height: 20px;
    }
    .exam_score{
        opacity: 0.7;
    }
    .exam_number{
        width: 20px;
        height: 20px;

        border-radius: 50px;
        background: #409EFF;
        text-align: center;
        line-height: 20px;
        color: #ffffff;
        font-size: 14px;
    }
}
.exam_info{
    display: inline-block;
    width: 100%;
    height: 30px;
    line-height: 30px;
    opacity: 0.7;
    font-size: 15px;
}
.content_paper{
    width: 100%;
}
.question_test{
    width: 80%;
    display: inline-block;
    line-height: 25px;
    box-sizing: border-box;
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.greetings::v-deep .el-input{
    width: 200px;
    margin-right: 20px;
}
</style>
